export default {
  grantUser: {
    message: 'manageMember.approveAccountMessage',
    ok: 'common.approve',
    cancel: 'common.cancel'
  },
  grantSelectedUser: {
    message: 'manageMember.approveSelectedAccountMessage',
    ok: 'common.approve',
    cancel: 'common.cancel'
  },
  rejectUser: {
    message: 'manageMember.declineAccountMessage',
    ok: 'common.decline',
    cancel: 'common.cancel',
    rejectReasons: [
      'manageMember.defaultRejectReason'
    ]
  },
  rejectSelectedUser: {
    message: 'manageMember.declineSelectedAccountMessage',
    ok: 'common.decline',
    cancel: 'common.cancel',
    rejectReasons: [
      'manageMember.defaultRejectReason'
    ]
  },
  removeUser: {
    message: 'manageMember.deleteUserMessage',
    ok: 'common.delete',
    cancel: 'common.cancel'
  },
  removeSelectedUser: {
    message: 'manageMember.deleteSelectedUserMessage',
    ok: 'common.delete',
    cancel: 'common.cancel'
  }
}



// WEBPACK FOOTER //
// ./src/data/manage-user.js